// Function for truncating strings
// Usage: import truncate from 'utils/truncate';
// Usage: truncate('Lorem ipsum dolor sit amet', 10) // 'Lorem ipsu...'

function truncate(str, n) {
    return str?.length > n ? `${str.slice(0, n)}...` : str;
}
export default truncate;
